import { useCallback } from 'react';

// inspired by
// https://medium.com/@teh_builder/ref-objects-inside-useeffect-hooks-eb7c15198780

export const useRefEffect = (action: (node: HTMLElement) => void, dependencies: any[]) =>
    useCallback((node) => {
        if (node) {
            action(node);
        }
    }, [ action]);